<template>
  <div
    class="c-library-topbar navbar is-fixed-top has-text-white">
    <div class="c-library-topbar__container container is-fluid" :class="isOnTablet ? 'c-library-topbar__container--tablet' : ''">
      <div
        v-if="bookArchive && bookArchive.currentStatus === 'READY_TO_ARCHIVE' || !isOnTablet"
        class="c-library-topbar__burger"
      >
        <button
          class="c-library-topbar__burger-button"
          aria-label="menu"
          :aria-expanded="`${menuIsOpen}`"
          @click="$emit('burger-clicked')">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </button>
      </div>
      <button
        v-else
        class="c-library-topbar__archive-cancel"
        @click="bookArchive && bookArchive.cancelArchiving()"
      >
        {{ $t('CANCEL') }}
      </button>
      <nav
        class="c-library-topbar__content navbar level"
        :class="isOnTablet ? 'c-library-topbar__content--tablet' : ''">
        <div class="c-library-topbar__logo">
          <offline-badge
            v-if="!connection"
            class="c-library-topbar__offline-badge"
            :class="isOnTablet ? 'c-library-topbar__offline-badge--tablet' : ''">
          </offline-badge>
          <figure class="c-library-topbar__figure media-content is-centered level-item" alt="D-bok logo">
            <router-link to="/library" class="c-library-topbar__logo-link">
              <d-bok-logo class="c-library-topbar__svg"></d-bok-logo>
            </router-link>
          </figure>
        </div>
        <div class="c-library-topbar__select-wrapper" v-if="isOnTablet && hasStoredBooks">
          <button
            v-if="bookArchive && bookArchive.currentStatus === 'READY_TO_ARCHIVE'"
            class="c-library-topbar__select"
            @click="bookArchive.setCurrentStatus('SELECT_TO_ARCHIVE')"
          >
            {{ $t('SELECT_TO_ARCHIVE') }}
          </button>
          <button
            v-else
            class="c-library-topbar__select active"
            @click="bookArchive.archiveSelected()"
          >
            {{ $t('ARCHIVE') }}
          </button>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import OfflineBadge from './OfflineBadge'
import DbokLogo from '@/assets/svg/DbokLogo'

export default {
  name: 'library-topbar',

  components: {
    'offline-badge': OfflineBadge,
    'd-bok-logo': DbokLogo,
  },

  props: {
    connection: {
      type: Boolean
    },
    isOnTablet: {
      type: Boolean,
      default: false
    },
    bookArchive: Object,
    menuIsOpen: Boolean
  },

  computed: {
    ...mapGetters('book', [
      'hasStoredBooks'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-library-topbar {
  position: fixed;
  z-index: 999999999;
}

.c-library-topbar,
.c-library-topbar__content {
  background: $blue;
  width: 100%;
  display: flex;
  max-height: 65px;
}

.c-library-topbar__logo {
  min-height: 65px;
  justify-content: left;
  margin-bottom: 0;
  width: 100%;
}
.c-library-topbar__logo-link {
  @include a11yOutline();
}

.c-library-topbar__burger {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 998;
  .c-library-topbar__burger-button {
    @include btnReset();
    width: 32px;
    height: 32px;
    background: transparent;
    margin: 1em;
    position: relative;
    cursor: pointer;

    @include a11yOutline();
  }
  span {
    background-color: $very-light-pink;
    color: $very-light-pink;
    height: 4px;
    width: 100%;
    left: 0;
    &:nth-child(1) {
      top: calc(50% + 7px);
    }
    &:nth-child(2) {
      top: calc(50% - 2px);
    }
    &:nth-child(3) {
      top: calc(50% - 11px);
    }

    display: block;
    position: absolute;
    transform-origin: center;
    transition-duration: 86ms;
    transition-property: background-color,opacity,-webkit-transform;
    transition-property: background-color,opacity,transform;
    transition-property: background-color,opacity,transform,-webkit-transform;
    transition-timing-function: ease-out;
  }
  &:hover {
    background: $lighter-dark-blue;
  }
}

.c-library-topbar__figure {
  position: absolute;
  left: 0;
  right: 0;
  width: 65px;
  height: 65px;
  margin: auto;
  top: 0;
}

.c-library-topbar__svg {
  width: 65px;
  height: 65px;
}

.c-library-topbar__container {
  margin: 0;
}

.c-library-topbar__container--tablet {
  margin: 0;
  display: flex;
}

.c-library-topbar__offline-badge {
  margin-left: 1.5em;
  top: 1.35rem;
  position: relative;
  &.c-library-topbar__offline-badge--tablet {
    margin-left: 5rem;
  }
}

.c-library-topbar__content--tablet {
  margin: 0 !important;
  position: static;
}

.c-library-topbar__select-wrapper {
  @include btnReset();
  margin: auto 0;
}

.c-library-topbar__select {
  @include btnReset();
  font-size: 17px;
  color: $very-light-pink;
  margin-right: 1em;
  cursor: pointer;

  @include a11yOutline();
}

.c-library-topbar__select.active {
  font-weight: 700;
}

.c-library-topbar__archive-cancel {
  @include btnReset();
  margin: auto 0 auto 1em;
  color: $white;
  cursor: pointer;
}

@media screen and (min-width: 769px) {
  .c-library-topbar__burger-button {
    display: block;
  }
}
</style>
